import React, { useMemo, useState } from 'react';
import axios from 'axios';
import useDetailFetch from '../../../../hooks/useDetailFetch';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { useParams, useNavigate } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';

const SingleOpportunityNoteDetails = () => {
  const { noteId } = useParams();
  const navigate = useNavigate();
  const decodedId = noteId ? atob(noteId) : noteId;
  const id = decodedId.replace(/\D/g, '');
  const [showDelete, setShowDelete] = useState(false);
  const { showToast } = React.useContext(ToastContext);

  const url = id ? `${API_DOMAIN}${API_ROUTES['opportunityNotes']}${id}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(API_DOMAIN + API_ROUTES['opportunityNotes'] + id + '/', { headers });
      showToast('Opportunity Note deleted successfully', 'success');
      navigate('/opportunity/note/list');
    } catch (error) {
      console.error('Error deleting Opportunity Note:', error);
      showToast('Failed to delete Opportunity Note', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        loading={loading}
        entityName="Opportunity Note"
        listPath="/opportunity/note/list"
        editPath={`/opportunity/note/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        isOpen={showDelete}
        title="Delete Opportunity Note"
        message="Are you sure you want to delete this Opportunity Note? This action cannot be undone."
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
        isDangerous={true}
      />
    </div>
  );
};

export default SingleOpportunityNoteDetails;
